<template>
  <auth-layout container-class="max-w-xl">
    <div>
      <h2 class="xl:text-4xl xl:font-light text-2xl font-bold">
        {{ state.title }}
      </h2>
      <p class="mt-2">
        <icon-link
          :href="route('login')"
          icon="arrow-thin-left-circle"
        >
          Back to login
        </icon-link>
      </p>
    </div>
    <div
      class="mb-12 content text-left"
      v-html="parseMarkdown(state.content)"
    />
  </auth-layout>
</template>

<script>
export default {
	name: 'AuthPage',
	created() {
		document.title = `${this.state.title} :: ${document.title}`;
	}
}
</script>
<style>
  .text h2 {
    @apply text-lg mb-2
  }
  .text p{
    @apply mb-4
  }
</style>

